module.exports = __webpack_public_path__ + "static/sharequest-c2284eb2b8e2973746eeec83a5464ffa.jpg";